import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { finalize } from 'rxjs';
import { UserService } from 'app/services/LupinoApi/user.service';

@Component({
    selector: 'app-password-forgotten',
    templateUrl: './password-forgotten.component.html',
    styleUrl: './password-forgotten.component.css',
    imports: [ReactiveFormsModule]
})
export class PasswordForgottenComponent {
	forgotForm: FormGroup;
	error = false;
	emailSent = false;
	isSending = false;

	constructor(private fb: FormBuilder, private userService: UserService) {
		this.forgotForm = this.fb.group({
			email: ['', [Validators.required, Validators.email]],
		});
	}

	onSubmit(): void {
		if (this.isSending) return;
		this.error = false;
		this.emailSent = false;
		if (this.forgotForm.invalid) {
			this.forgotForm.markAllAsTouched();
			return;
		}

		this.isSending = true;
		this.userService.sendForgotPasswordEmail(this.forgotForm.value.email)
			.pipe(finalize(() => this.isSending = false))
			.subscribe({
				next: (data) => {
					this.emailSent = data?.result === 'OK';
					this.error = !this.emailSent;
				},
				error: () => this.error = true,
			});
	}
}